import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { localizable } from '../Localization';

@localizable
@observer
export default class BuyerDocumentSelector extends Component {
  handleChange = (doc, checked) => {
    const { required, disabled } = this.props;
    let _disabled = Array.isArray(disabled) ? disabled : [disabled];

    if (_disabled.includes(doc)) return; // disabled item cannot be checked/unchecked

    const index = required.indexOf(doc);
    const exists = index !== -1;
    if (checked && !exists) {
      required.push(doc);
    }
    if (!checked && exists) {
      required.splice(index, 1);
    }
  };

  render() {
    const { options, label, required, disabled } = this.props;

    if (!options || !options.length) {
      return <React.Fragment></React.Fragment>;
    }
    let _disabled = Array.isArray(disabled) ? disabled : [disabled];
    return (
      <div className="ms-Grid" style={{ margin: '1em 0' }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm6">{label}</div>
        </div>
        {options.map((o) => {
          return (
            <div key={o.key} className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm6">
                <Checkbox
                  label={o.text}
                  checked={required.indexOf(o.key) !== -1}
                  disabled={_disabled.includes(o.key)}
                  onChange={(_, checked) => this.handleChange(o.key, checked)}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/BuyerDocumentSelector/OnlyRequired.jsx